import { render, staticRenderFns } from "./StatsExcaption.vue?vue&type=template&id=e86dbef0&scoped=true&"
import script from "./StatsExcaption.vue?vue&type=script&lang=ts&"
export * from "./StatsExcaption.vue?vue&type=script&lang=ts&"
import style0 from "./StatsExcaption.vue?vue&type=style&index=0&id=e86dbef0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e86dbef0",
  null
  
)

export default component.exports